.tileContainer {
    margin: 0;
    padding: 0;
    position: relative;

    figcaption {
        text-align: center;
        font-size: 1.6em;
        margin-top: 9px;
        text-transform: uppercase;
        line-height: 0.9;
    }
}
